export function round(num: number, numberOfDecimals = 2): number {
  const factor = 10 ** numberOfDecimals;
  return Math.round((num + Number.EPSILON) * factor) / factor;
}
